export { default as FAB } from './component';
